import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import { calculateAge, StarSymbol } from '../../Style';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BOOKING_AIRPORT_DETAILS,
  BOOKING_SUMMARY,
  UNAUTHORIZE_BOOKING_AIRPORT,
  UNAUTHORIZE_BOOKING_SUMMARY,
} from '../../component/common/Routes/AppRoutes';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import ControlledInput from '../../component/ui/FormFields/ControlledInput';
import CustomButton from '../../component/ui/FormFields/Button';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from '../../redux/Common/selectorAction';
import { useDispatch, useSelector } from 'react-redux';
import {
  VENDOR_BOOKING_AIRPORT_DETAILS,
  VENDOR_BOOKING_SUMMARY,
} from '../../component/common/Routes/VendorRoutes';
import {
  CUSTOMER_BOOKING_AIRPORT_DETAILS,
  CUSTOMER_BOOKING_SUMMARY,
} from '../../component/common/Routes/CustomerRoutes';
import {
  addBillingAddressRequest,
  fetchBillingAddressesRequest,
  resetBillingAddressState,
} from '../../redux/BillingAddress/BillingAddressAction';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';
import { toast, ToastContainer } from 'react-toastify';
import AddAddressForm from '../Address/AddAddress';
import BookingAddAddressForm from '../Address/BookingBillingAddress';
import TopBar from '../../component/common/components/TopBar';
import { Email } from '@mui/icons-material';

const Form2 = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const form1Value = location.state?.form1Value || {};
  const form2Value = location.state?.form2Value || {};
  const form3Value = location.state?.form3Value || {};
  console.log("form2value",form2Value)
 
  const serviceType=[form1Value?.service_type?.value,form1Value?.transit_service?.label];
 const  isInternationalService=serviceType?.some((service)=>service?.toLowerCase().includes("international"));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [selectedAddress, setSelectedAddress] = useState('');
  

  const scrollToError = (errors) => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length === 0) return;

    const getFirstErrorFieldName = (errors) => {
      for (const key of errorKeys) {
        if (errors[key]) {
          if (Array.isArray(errors[key])) {
            for (let i = 0; i < errors[key].length; i++) {
              if (errors[key][i]) {
                const nestedKeys = Object.keys(errors[key][i]);
                if (nestedKeys.length > 0) {
                  return `${key}.${i}.${nestedKeys[0]}`;
                }
              }
            }
          } else if (typeof errors[key] === 'object' && errors[key].message) {
            return key;
          }
        }
      }
      return errorKeys[0];
    };

    const firstErrorField = getFirstErrorFieldName(errors);
    const selectors = [
      `[name="${firstErrorField}"]`,
      `[name*="${firstErrorField}"]`,
      `input[name="${firstErrorField}"]`,
      `input[name*="${firstErrorField}"]`,
      `textarea[name="${firstErrorField}"]`,
      `select[name="${firstErrorField}"]`,
      `.MuiFormControl-root:has([name="${firstErrorField}"])`,
      `.MuiFormControl-root:has([name*="${firstErrorField}"])`,
    ];

    let element = null;
    for (const selector of selectors) {
      element = document.querySelector(selector);
      if (element) break;
    }

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      setTimeout(() => {
        element.focus();
      }, 300);
    } else {
      const formElement =
        document.querySelector('form') ||
        document.querySelector('.booking-wrapper');
      if (formElement) {
        formElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  useEffect(() => {
    document.body.classList.add('booking-page');
    return () => {
      document.body.classList.remove('booking-page');
    };
  }, []);

  useEffect(() => {
    setSelectedAddress(form2Value.billing_address);
  }, [form2Value.billing_address]);

  const {
    formState: { errors },
    control,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      no_of_adult: form2Value.no_of_adult || '',
      no_of_child: form2Value.no_of_child || '',
      no_of_infant: form2Value.no_of_infant || '',
      no_of_service: form2Value.no_of_service || '',
      total_passengers: form2Value.total_passengers || '',

      city: form2Value?.city
        ? {
            label: form2Value?.city?.label.replace('_', ' ').toUpperCase(),
            value: form2Value?.city?.value,
          }
        : null,
      company_name: form2Value?.company_name,
      address1: form2Value?.address1,
      address2: form2Value?.address2,
      pincode: form2Value?.pincode,
      first_name: form2Value?.first_name,
      last_name: form2Value?.last_name,
      phone: form2Value?.phone,
      emergency_contact: form2Value?.emergency_contact,
      country_code: form2Value?.country_code,
      emergency_country_code: form2Value?.emergency_country_code,
      state: form2Value?.state
        ? {
            label: form2Value?.state?.label.replace('_', ' ').toUpperCase(),
            value: form2Value?.state?.value,
          }
        : null,
      country: form2Value?.country
        ? {
            label: form2Value?.country?.label.replace('_', ' ').toUpperCase(),
            value: form2Value?.country?.value,
          }
        : null,

      notes: form2Value.notes || '',
      email: form2Value?.email,
      dob: form2Value?.dob,
      gst_number: form2Value?.gst_number || '',
      company_name: form2Value.company_name || '',
      gstin_number: form2Value.gstin_number || '',
      pincode: form2Value.pincode || '',
      address: form2Value.address || '',
      passport_number:form2Value?.passport_number||'',
      adults: form2Value.adults || [
        {
          first_name: '',
          last_name: '',
          age: '',
          phone: '',
          gender_type: '',
          country_code: '',
          passport_number: '',
          aadhar_number: '',
          nationality: '',
          type: '3',
        },
      ],
      children: form2Value.children || [
        {
          first_name: '',
          last_name: '',
          age: '',
          country_code: '',
          phone: '',
          gender_type: '',
          nationality: '',
          passport_number: '',
          aadhar_number: '',
          type: '2',
        },
      ],
      infants: form2Value.infants || [
        {
          first_name: '',
          last_name: '',
          age: '',
          country_code: '',
          phone: '',
          type: '1',
          gender_type: '',
          nationality: '',
          passport_number: '',
          aadhar_number: '',
          type: '1',
        },
      ],
    },
  });

  // address selector
  useEffect(() => {
    dispatch(selectCountryRequest());
  }, []);

  const formValue = watch();
  
  const countryId = formValue.country?.value;
  const stateId = formValue.state?.value;
  const countries = useSelector((state) => state.selector?.country?.data);
 
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });

 
  useEffect(() => {
    dispatch(resetBillingAddressState());
  }, []);


  let bookingsRoute;

  bookingsRoute = UNAUTHORIZE_BOOKING_AIRPORT;

  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });

  useEffect(() => {
    if (countryId > 0) {
      dispatch(selectStateRequest(countryId));
    }
  }, [countryId]);

  useEffect(() => {
    if (stateId > 0) {
      dispatch(selectCityRequest(stateId));
    }
  }, [stateId]);

  const navigate = useNavigate();
  const formValues = watch();
  const formValuess = {
    ...formValues,
  };

  const {
    fields: adultFields,
    append: appendAdult,
    remove: removeAdult,
  } = useFieldArray({
    control,
    name: 'adults',
  });
  const {
    fields: childFields,
    append: appendChild,
    remove: removeChild,
  } = useFieldArray({
    control,
    name: 'children',
  });
  const {
    fields: infantFields,
    append: appendInfant,
    remove: removeInfant,
  } = useFieldArray({
    control,
    name: 'infants',
  });

  useEffect(() => {
    const infantCount = parseInt(formValues.no_of_infant || 0, 10);
    if (infantCount !== infantFields.length) {
      if (infantCount > infantFields.length) {
        for (let i = infantFields.length; i < infantCount; i++) {
          appendInfant({
            first_name: '',
            last_name: '',
            age: '',
            country_code: '',
            phone: '',
            gender_type: '',
            nationality: '',
            passport_number: '',
            aadhar_number: '',
            type: '1',
          });
        }
      } else {
        for (let i = infantFields.length - 1; i >= infantCount; i--) {
          removeInfant(i);
        }
      }
    }

    const childCount = parseInt(formValues.no_of_child || 0, 10);
    if (childCount !== childFields.length) {
      if (childCount > childFields.length) {
        for (let i = childFields.length; i < childCount; i++) {
          appendChild({
            first_name: '',
            last_name: '',
            age: '',
            country_code: '',
            phone: '',
            nationality: '',
            gender_type: '',
            passport_number: '',
            aadhar_number: '',
            type: '2',
          });
        }
      } else {
        for (let i = childFields.length - 1; i >= childCount; i--) {
          removeChild(i);
        }
      }
    }

    const adultCount = parseInt(formValues.no_of_adult || 0, 10);
    if (adultCount !== adultFields.length) {
      if (adultCount > adultFields.length) {
        for (let i = adultFields.length; i < adultCount; i++) {
          appendAdult({
            first_name: '',
            last_name: '',
            age: '',
            country_code: '',
            phone: '',
            nationality: '',
            gender_type: '',
            passport_number: '',
            aadhar_number: '',
            type: '3',
          });
        }
      } else {
        for (let i = adultFields.length - 1; i >= adultCount; i--) {
          removeAdult(i);
        }
      }
    }
  }, [
    formValues.no_of_infant,
    formValues.no_of_child,
    formValues.no_of_adult,
    infantFields.length,
    childFields.length,
    adultFields.length,
    appendInfant,
    removeInfant,
    appendChild,
    removeChild,
    appendAdult,
    removeAdult,
  ]);
const servicePlan=[form1Value?.arrival_plan?.label,form1Value?.departure_plan?.label,form1Value?.transit_plan?.label];
  const isPorterService=servicePlan?.some((service)=> service?.toLowerCase().includes("porter"));
  const formFields = [
    {
      name: 'no_of_adult',
      label: 'No of Adults',
      placeholder: 'Enter number of adults',
      type: 'text',
      rules: { required: false },
      xs: 12,
      md: 6,
    },
    {
      name: 'no_of_child',
      label: 'No of Child',
      placeholder: 'Enter number of children',
      type: 'text',
      rules: { required: false },
      xs: 12,
      md: 6,
    },
    {
      name: 'no_of_infant',
      label: 'No of Infant',
      placeholder: 'Enter number of infants',
      type: 'text',
      rules: { required: false },
      xs: 12,
      md: 6,
    },
    {
      name: 'total_passengers',
      label: 'Total Passengers *',
      placeholder: 'Calculated total',
      type: 'number',
      disabled: true,
      rules: {
        required: true,
        validate: (value) =>
          value > 0 || 'Total passengers must be greater than zero',
      },
      xs: 12,
      md: 6,
    },
    {
      name: 'notes',
      label: 'Notes',
      placeholder: 'Enter any notes',
      type: 'text',
      rules: { required: false },
      xs: 12,
      md: 6,
    },
    {
      name: 'no_of_service',
      label: 'No of Service *',
      placeholder: 'Enter number of services required',
      type: 'text',
      disabled:isPorterService? false:true,
      rules: { required: 'Required Service is Needed' },
      xs: 12,
      md: 6,
    },
  ];

  const passengerDetails = [
    {
      name: 'first_name',
      label: 'First Name *',
      placeholder: 'Enter first name',
      rules: { required: 'First Name is Required' },
      xs: 12,
      sm: 6,
    },
    {
      name: 'last_name',
      label: 'Last Name *',
      placeholder: 'Enter last name',
      rules: { required: 'Last Name is Required' },
      xs: 12,
      sm: 6,
    },
    {
      name: 'dob',
      label: 'Date of Birth *',
      placeholder: 'Select date of birth',
      type: 'dob',
      rules: {
        adult: {
          required: 'Date of Birth is required',
          validate: (dob) => {
            const age = calculateAge(dob);
            if (age < 12) return 'Adult age must be 12 or older';
            return true;
          },
        },
        child: {
          required: 'Date of Birth is required',
          validate: (dob) => {
            const age = calculateAge(dob);
            if (age < 2 || age > 11)
              return 'Child age must be between 2 and 11';
            return true;
          },
        },
        infant: {
          required: 'Date of Birth is required',
          validate: (dob) => {
            const age = calculateAge(dob);
            if (age >= 2) return 'Infant age must be less than 2';
            return true;
          },
        },
      },
      xs: 12,
      sm: 6,
    },
    // {
    //   name: "aadhar_number",
    //   label: "Aadhar Number",
    //   placeholder: "Enter Aadhar Number",
    //   type: "Number",
    //   rules: {
    //     validate: {
    //       aadharFormat: (value) => {
    //         if (!value || value.trim() === "") return true;
    //         return (
    //           /^\d{12}$/.test(value) ||
    //           "Aadhar Number must be exactly 12 digits"
    //         );
    //       },
    //     },
    //   },
    //   xs: 12,
    //   sm: 6,
    // },
    ...(isInternationalService
      ? [
          {
            name: 'passport_number',
            label: 'Passport Number',
            placeholder: 'Enter Passport Number',
            type: 'Text',
            rules: {
              required: 'Passport is required for international flights',
              validate: {
                passportFormat: (value) => {
                  if (!value || value.trim() === '') {
                    return 'Passport is required for international flights';
                  }

                  const patterns = {
                    US: /^[0-9]{9}$/,
                    UK: /^[0-9]{9}$|^[A-Z]{2}[0-9]{7}$/,
                    EU: /^[A-Z]{1,2}[0-9]{5,7}$/,
                    CA: /^[A-Z]{2}[0-9]{6}$/,
                    AU: /^[A-Z][0-9]{8}$/,
                    IN: /^[A-Z][0-9]{7}$/,
                    general: /^[A-Z0-9]{5,12}$/i,
                  };

                  return (
                    patterns.US.test(value) ||
                    patterns.UK.test(value) ||
                    patterns.EU.test(value) ||
                    patterns.CA.test(value) ||
                    patterns.AU.test(value) ||
                    patterns.IN.test(value) ||
                    patterns.general.test(value) ||
                    'Please enter a valid passport number'
                  );
                },
              },
            },
            xs: 12,
            sm: 6,
          },
        ]
      : []),
    {
      name: 'nationality',
      label: 'Nationality *',
      placeholder: 'Enter Nationality',
      rules: {
        required: 'Nationality is required',
      },
      xs: 12,
      sm: isInternationalService ? 12 : 6,
    },
    {
      name: 'country_code',
      options: countryForCode,
      rules: {
        adult: { required: 'Country Code is Required' },
        child: { required: false },
        infant: { required: false },
      },
      label: 'Country Code',
      placeholder: 'Enter Country Code',
      sm: 4,
      xs: 4,
    },
    {
      name: 'phone',
      label: 'Mobile No',
      placeholder: 'Enter mobile number',
      rules: {
        adult: {
          required: 'Mobile No is Required',
          pattern: {
            value: /^\d+$/,
            message: 'Enter only numeric digits',
          },
        },
        child: {
          required: false,
          pattern: {
            value: /^\d+$/,
            message: 'Enter only numeric digits',
          },
        },
        infant: {
          required: false,
          pattern: {
            value: /^\d+$/,
            message: 'Enter only numeric digits',
          },
        },
      },
      xs: 8,
      sm: 8,
    },
    {
      name: 'gender_type',
      label: 'Gender *',
      type: 'radio',
      radioOptions: [
        { value: 'M', label: 'Male' },
        { value: 'F', label: 'Female' },
        { value: 'O', label: 'Other' },
      ],
      rules: { required: 'Select Gender' },
    },
  ];


                
  useEffect(() => {
     console.log("isPorterService",isPorterService)
    const totalPassengers =
      (parseInt(formValues.no_of_adult) || 0) +
      (parseInt(formValues.no_of_child) || 0) +
      (parseInt(formValues.no_of_infant) || 0);
    const totalServices =
      (parseInt(formValues.no_of_adult) || 0) +
      (parseInt(formValues.no_of_child) || 0);

    setValue('total_passengers', totalPassengers);
   !isPorterService && setValue('no_of_service',totalServices);
    if (totalPassengers > 0) {
      clearErrors('total_passengers');
    }
  }, [
    formValues.no_of_adult,
    formValues.no_of_child,
    formValues.no_of_infant,
    setValue,
    clearErrors,
    isInternationalService
  ]);

  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);

  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });

  const fields = [
    {
      name: 'first_name',
      label: 'First Name (If Company, Enter Company Details) *',
      type: 'text',
      rules: { required: 'First Name is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'last_name',
      label: 'Last Name ',
      type: 'text',
      sm: 6,
      xs: 12,
    },
    {
      name: 'dob',
      label: 'Date of Birth *',
      label: 'Date of Birth (For Companies, Enter a Dummy Date Above Age 12 )*',
      type: 'dob',
      rules: { required: 'Date of Birth is required' },
      xs: 12,
      sm: 6,
    },
    {
      name: 'email',
      label: 'Email *',
      placeholder: 'Enter Email Address',
      icon: <Email />,
      rules: {
        required: 'Email Address is required',
        pattern: {
          value: /^\S+@\S+\.\S+$/,
          message: 'Enter a valid email address',
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: 'address1',
      label: 'Address Line 1 *',
      type: 'text',
      rules: { required: 'Address Line 1 is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'address2',
      label: 'Address Line 2',
      type: 'text',
      sm: 6,
      xs: 12,
    },
    {
      name: 'country',
      label: 'Country *',
      type: 'text',
      options: countryName,
      rules: { required: 'Country is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'state',
      label: 'State *',
      type: 'text',
      options: stateName,
      rules: { required: 'State is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'city',
      label: 'City *',
      type: 'text',
      options: cityName,
      rules: { required: 'City is required' },
      sm: 6,
      xs: 12,
    },
    {
      name: 'pincode',
      label: 'Pincode *',
      type: 'text',
      rules: {
        required: 'Pincode is required',
        pattern: {
          value: /^[0-9]+$/,
          message: 'Enter a valid numeric pincode',
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: 'country_code',
      options: countryForCode,
      label: 'code',
      rules: {
        required: 'Code is Required',
      },
      sm: 2,
      xs: 4,
    },
    {
      name: 'phone',
      label: 'Phone Number *',
      type: 'text',
      rules: {
        required: 'Mobile Number is required',
        pattern: {
          value: /^\d+$/,
          message: 'Enter only numeric digits',
        },
      },
      sm: 4,
      xs: 8,
    },
    {
      name: 'emergency_country_code',
      options: countryForCode,
      label: 'country Code *',
      rules: {
        required: 'Code is Required',
      },
      sm: 2,
      xs: 4,
    },
    {
      name: 'emergency_contact',
      label: 'Emergency Contact *',
      type: 'text',
      rules: {
        required: 'Emergency Contact is required',
        pattern: {
          value: /^\d+$/,
          message: 'Enter only numeric digits',
        },
      },
      sm: 4,
      xs: 8,
    },
      
  {
  name: 'pan_number',
  label: 'PAN Number',
  type: 'text',
  rules: {
    required: false, // <-- explicitly optional
    validate: (value) => {
      if (value) {
        const validFormat = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value); 
        if (!validFormat) {
          return 'Invalid PAN format (e.g., ABCDE1234F)';
        }
      }
      return true;
    },
  },
  sm: 6,
  xs: 12,
},
{
  name: 'customer_gst_no',
  label: 'GST Number',
  type: 'text',
  rules: {
    required: false, // <-- explicitly optional
    validate: (value) => {
      if (value) {
        const validFormat = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);
        if (!validFormat) {
          return 'Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)';
        }
      }
      return true;
    },
  },
  sm: 6,
  xs: 12,
},
    ...(isInternationalService
      ? [
          {
            name: 'passport_number',
            label: 'Passport Number',
            placeholder: 'Enter Passport Number',
            type: 'Text',
            rules: {
              required: 'Passport is required for international flights',
              validate: {
                passportFormat: (value) => {
                  if (!value || value.trim() === '') {
                    return 'Passport is required for international flights';
                  }

                  const patterns = {
                    US: /^[0-9]{9}$/,
                    UK: /^[0-9]{9}$|^[A-Z]{2}[0-9]{7}$/,
                    EU: /^[A-Z]{1,2}[0-9]{5,7}$/,
                    CA: /^[A-Z]{2}[0-9]{6}$/,
                    AU: /^[A-Z][0-9]{8}$/,
                    IN: /^[A-Z][0-9]{7}$/,
                    general: /^[A-Z0-9]{5,12}$/i,
                  };

                  return (
                    patterns.US.test(value) ||
                    patterns.UK.test(value) ||
                    patterns.EU.test(value) ||
                    patterns.CA.test(value) ||
                    patterns.AU.test(value) ||
                    patterns.IN.test(value) ||
                    patterns.general.test(value) ||
                    'Please enter a valid passport number'
                  );
                },
              },
            },
            xs: 12,
            sm: 6,
          },
        ]
      : []),
  ];

  // Modified form submission handler
  const onSubmit = (data) => {
    dispatch(resetBookingDetails());
    let summaryRoute = UNAUTHORIZE_BOOKING_SUMMARY;

    if (summaryRoute) {
      navigate(summaryRoute, {
        state: {
          form1Value: form1Value,
          form2Value: formValuess,
          form3Value: form3Value,
        },
      });
    }
  };

  const onError = (errors) => {
    // Scroll to the first error field when validation fails
    scrollToError(errors);
  };

  return (
    <>
      <TopBar unAuth={true} />
      <ToastContainer />
      <Box className='container'>
        <Box sx={{ marginTop: '100px', marginBottom: '50px' }}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Grid container spacing={1}>
              <Grid item xs={12} xl={8}>
                <Box
                  className='unauth-add-booking-passenger-details booking-wrapper'
                  component={Paper}
                >
                  <Grid item xs={12}>
                    <Typography variant='h5' className='form-heading'>
                      Booking Details
                    </Typography>
                  </Grid>

                  <Box className='add-booking-form'>
                    <Grid container xs={12} spacing={3}>
                      {formFields.map((field, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={field.sm}
                          md={field.md}
                          lg={field.lg}
                          key={index}
                        >
                          <ControlledInput
                            name={field.name}
                            control={control}
                            rules={field.rules}
                            type={field.type}
                            disabled={field.disabled}
                            label={field.label}
                            radioOptions={field.radioOptions}
                            placeholder={field.placeholder}
                            options={field.options}
                            getOptionLabel={(option) => option.label}
                            error={!!errors[field.name]}
                            helperText={errors[field.name]?.message}
                          />
                        </Grid>
                      ))}
                      <Grid item xs={12}>
                        <Typography variant='h5' className='form-heading'>
                          Enter Billing Address
                        </Typography>
                      </Grid>

                      {fields.map((field, index) => (
                        <Grid item xs={field.xs} sm={field.sm} key={index}>
                          <ControlledTextInputField
                            name={field.name}
                            control={control}
                            setValue={setValue}
                            label={field.label}
                            placeholder={field.label}
                            rules={field.rules}
                            options={field.options}
                            type={field.type}
                            error={!!errors[field.name]}
                            helperText={errors[field.name]?.message}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              </Grid>
              {formValues.total_passengers > 0 && (
                <Grid item xs={12} xl={4}>
                  <Box
                    component={Paper}
                    elevation={3}
                    className='unauth-passenger-details-enter-form-body'
                  >
                    <Typography
                      variant='h5'
                      className='form-heading'
                      gutterBottom
                    >
                      Passenger Details
                    </Typography>

                    {/* Scrollable Content */}
                    {formValues?.no_of_adult > 0 && (
                      <>
                        <Divider textAlign='center' sx={{ mb: 2 }}>
                          Adult
                        </Divider>
                        {adultFields.map((field, index) => (
                          <Box key={field.id || index} mb={3}>
                            <Divider textAlign='left' sx={{ mb: 2 }}>
                              Adult {index + 1}
                            </Divider>

                            <Grid container spacing={3}>
                              {passengerDetails.map((config) => (
                                <Grid
                                  item
                                  xs={config.xs}
                                  sm={config.type === 'radio' ? 12 : config.sm}
                                  key={config.name}
                                >
                                  <ControlledTextInputField
                                    control={control}
                                    name={`adults.${index}.${config.name}`}
                                    defaultValue={field[config.name] || ''}
                                    rules={
                                      config.name === 'dob'
                                        ? config.rules?.adult
                                        : config.name === 'country_code'
                                        ? config.rules?.adult // Use adult-specific rules
                                        : config.name === 'phone'
                                        ? config.rules?.adult // Use adult-specific rules
                                        : config.rules
                                    }
                                    label={config.label}
                                    size='small'
                                    adultIndex={index}
                                    setValue={setValue}
                                    placeholder={config.placeholder}
                                    type={config.type || 'text'}
                                    options={config.options}
                                    getOptionLabel={(option) => option.label}
                                    radioOptions={config.radioOptions}
                                    error={
                                      errors.adults?.[index]?.[config.name]
                                        ?.message
                                    }
                                    helperText={
                                      errors.adults?.[index]?.[config.name]
                                        ?.message
                                    }
                                  />
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        ))}
                      </>
                    )}

                    {formValues?.no_of_child > 0 && (
                      <>
                        <Divider textAlign='center' sx={{ mb: 2 }}>
                          Children
                        </Divider>
                        {childFields.map((field, index) => (
                          <Box key={field.id} mb={3}>
                            <Divider textAlign='left' sx={{ mb: 2 }}>
                              Child {index + 1}
                            </Divider>
                            <Grid container spacing={3}>
                              {passengerDetails.map((config) => (
                                <Grid
                                  item
                                  xs={config.xs}
                                  sm={config.type === 'radio' ? 12 : config.sm}
                                  key={config.name}
                                >
                                  <ControlledTextInputField
                                    control={control}
                                    name={`children.${index}.${config.name}`}
                                    defaultValue={field[config.name] || ''}
                                    rules={
                                      config.name === 'dob'
                                        ? config.rules.child
                                        : config.name === 'country_code'
                                        ? config.rules?.child // Use child-specific rules (not required)
                                        : config.name === 'phone'
                                        ? config.rules?.child // Use child-specific rules (not required)
                                        : config.rules
                                    }
                                    size='small'
                                    label={config.label}
                                    placeholder={config.placeholder}
                                    type={config.type || 'text'}
                                    childIndex={index}
                                    options={config.options}
                                    setValue={setValue}
                                    getOptionLabel={(option) => option.label}
                                    radioOptions={config.radioOptions}
                                    error={
                                      errors.children?.[index]?.[config.name]
                                        ?.message
                                    }
                                    helperText={
                                      errors.children?.[index]?.[config.name]
                                        ?.message
                                    }
                                  />
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        ))}
                      </>
                    )}

                    {formValues?.no_of_infant > 0 && (
                      <>
                        <Divider textAlign='center' sx={{ mb: 2 }}>
                          Infants
                        </Divider>
                        {infantFields.map((field, index) => (
                          <Box key={field.id} mb={3}>
                            <Divider textAlign='left' sx={{ mb: 2 }}>
                              Infant {index + 1}
                            </Divider>
                            <Grid container spacing={3}>
                              {passengerDetails.map((config) => (
                                <Grid
                                  item
                                  xs={config.xs}
                                  sm={config.type === 'radio' ? 12 : config.sm}
                                  key={config.name}
                                >
                                  <ControlledTextInputField
                                    control={control}
                                    name={`infants.${index}.${config.name}`}
                                    defaultValue={field[config.name] || ''}
                                    rules={
                                      config.name === 'dob'
                                        ? config.rules.infant
                                        : config.name === 'country_code'
                                        ? config.rules?.infant // Use infant-specific rules (not required)
                                        : config.name === 'phone'
                                        ? config.rules?.infant // Use infant-specific rules (not required)
                                        : config.rules
                                    }
                                    size='small'
                                    setValue={setValue}
                                    label={config.label}
                                    placeholder={config.placeholder}
                                    type={config.type || 'text'}
                                    options={config.options}
                                    infantIndex={index}
                                    getOptionLabel={(option) => option.label}
                                    radioOptions={config.radioOptions}
                                    error={
                                      errors.infants?.[index]?.[config.name]
                                        ?.message
                                    }
                                    helperText={
                                      errors.infants?.[index]?.[config.name]
                                        ?.message
                                    }
                                  />
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        ))}
                      </>
                    )}
                    <Box px={2} mb={2}>
                      <Typography className='typography-message'>
                        <StarSymbol>*</StarSymbol> For special requests or
                        unavailable dates, call our customer care @ +91-7 44 888
                        77 11.
                      </Typography>
                      <Typography className='typography-message' mt={1}>
                        <StarSymbol>*</StarSymbol> Each service covers
                        assistance for one guest and up to three bags,
                        regardless of the total number of passengers or bags.
                        Infants aged 0-2 years are complimentary, while children
                        aged 2-12 years receive a 30% discount on the adult
                        rate.
                      </Typography>
                      <Typography className='typography-message' mt={1}>
                        <StarSymbol>*</StarSymbol> For additional services
                        related to children, please ensure you book the
                        necessary number of services.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              )}
              {/* Navigation Buttons */}
              <Grid item xs={12}>
                <Box className='unauth-button-passenger-container'>
                  <CustomButton
                    variant='contained'
                    className='cancel-button'
                    type='button'
                    text={'back'}
                    state1={form1Value}
                    state2={formValuess}
                    state3={form3Value}
                    link={bookingsRoute}
                  />
                  <CustomButton
                    variant='contained'
                    className='success-button'
                    type='Submit'
                    onClick={() => {
                      dispatch(resetBookingDetails());
                    }}
                    text={'Submit'}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </>
  );
};
export default Form2;
